import { ITheme, IStyle, mergeStyleSets } from "@fluentui/react";
import { BwjPalette } from "../../app/app-theme";

export const PRIVATE_GET_STYLE_CLASSES = (theme: ITheme) => {

  const button: IStyle = {
      margin: 0,
      marginRight: 10,
      border: 'none',
      borderLeft: '1px solid',
      borderRight: '1px solid',
      borderColor: BwjPalette.themePrimaryDark,
      padding: '0 9px',
      display: 'flex',
      height: '100%',
      minWidth: 48,
      alignItems: 'center',
      justifyContent: 'center',
      color: theme.palette.white,
      backgroundColor: BwjPalette.themePrimaryDark,
      '&:hover': {
          borderColor: theme.palette.themeDarkAlt,
          backgroundColor: theme.palette.themeDarker,
      },
      '&:focus': {
          borderColor: theme.palette.white,
          borderLeftStyle: 'dotted',
          borderRightStyle: 'dotted',
          backgroundColor: theme.palette.themeDarker,
      },
      position: 'relative',
  };

  const icon: IStyle = {
      fontSize: 24,
  };

  const notificationIndicator: IStyle = {
      width: 10,
      height: 10,
      borderRadius: 5,
      backgroundColor: theme.palette.themePrimary,
      position: 'absolute',
      right: 8,
      bottom: 8,
  };

  return mergeStyleSets({
      button,
      icon,
      notificationIndicator,
  });
};